import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import BasicDialog from "../../base/BasicDialog";
import LoaderWrapper from "../../wrapper/LoaderWrapper";
import { useAsync } from "../../../hooks/useAsync";
import { useForm } from "../../../hooks/useForm";
import React, { useCallback, useEffect } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { isEmptyObject, isEmptyValue } from "../../../helpers/methods";
import { useCrudFn } from "../../../hooks/useCrudFn";


const UniversalDetailsDialog = (props) => {
  const { t } = useTranslation();

  const {
    formValue,
    setFormValue,
    onChange,
    onChangeWithCallback,
    onChangeDate,
    onChangeDateTime,
    onChangeAutocompleteFieldWithObjectOptions,
    onChangeAutocompleteFieldWithObjectOptionsAndCallback
  } = useForm(props.initForm);

  const {
    onCreateObject,
    onUpdateObject,
    isCreatingLoading,
    isUpdatingLoading,
  } = useCrudFn(
    props.onCreateFn,
    props.onUpdateFn,
    props.onDeleteFn,
    props.type
  )


  const detailsData = useAsync(() => {
    if (props.elementId) {
      return props.getDetails(props.elementId);
    }

    return Promise.resolve({ ...formValue })
  }, [props.elementId]);


  useEffect(() => {
    if (detailsData.loading) {
      return;
    }
    if (!isEmptyObject(detailsData.value)) {
      setFormValue(detailsData.value);
    }
  }, [detailsData.loading]);

  const handleRefetch = useCallback(() => {
    props.onClose()
    if (props.onRefetchData) props.onRefetchData()
  }, [formValue])


  const onSubmit = useCallback(() => {
    let dataToSave  = {...formValue}
    if (props.saveFn){
      dataToSave = props.saveFn(formValue)
    }
    if (props.saveLocal){
      
      props.onSaveLocal(dataToSave)
    } else if (props.elementId) {
      onUpdateObject(props.elementId, dataToSave, handleRefetch)
    } else {
      onCreateObject(dataToSave, handleRefetch)
    }
  }, [props.elementId, formValue, props.saveFn]);

  const isValid = formValue
      ? props.required_fields.every(
        (fieldName) => !isEmptyValue(formValue[fieldName])
      ) 
      : false;
      


  return (
    <BasicDialog
      open={props.open}
      onClose={props.onClose}
      titleAlign="center"
      contentAlign="center"
      title={props.elementId ? t(`dialog.${props.type}_dialog.${props.type}_details`) : t(`dialog.${props.type}_dialog.add_${props.type}`)}
      maxWidth={props.maxWidth}
      showDialogActions
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        rowGap={1}
      >
        <LoaderWrapper showLoader={detailsData.loading} >
          <Grid item xs={12}>
            {React.cloneElement(props.detailsForm, {
              formValue: formValue,
              setFormValue: setFormValue,
              onChange: onChange,
              onChangeWithCallback: onChangeWithCallback,
              onChangeAutocomplete: onChangeAutocompleteFieldWithObjectOptions,
              onChangeAutocompleteWithCallback: onChangeAutocompleteFieldWithObjectOptionsAndCallback,
              onChangeDate: onChangeDate,
              onChangeDateTime: onChangeDateTime,
              filteringData: props.filteringData
            })}
          </Grid>
          <Grid item xs={12}>
            <LoadingButton
              variant="contained"
              color="primary"
              fullWidth
              loading={isCreatingLoading || isUpdatingLoading}
              disabled={!isValid}
              onClick={onSubmit}
            >
              {props.elementId ? t("save") : t("create")}
            </LoadingButton>
          </Grid>
        </LoaderWrapper>
      </Grid>
    </BasicDialog>
  );
};

UniversalDetailsDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  required_fields: PropTypes.array,
  initForm: PropTypes.object,
  onCreateFn: PropTypes.func,
  onUpdateFn: PropTypes.func,
  onDeleteFn: PropTypes.func,
  getDetails: PropTypes.func,
  onRefetchData: PropTypes.func,
  type: PropTypes.string,
  elementId: PropTypes.string,
  filteringData: PropTypes.object,
  detailsForm: PropTypes.object,
  maxWidth: PropTypes.string,
  disabledButton : PropTypes.bool,
  onValid: PropTypes.func,
  saveFn : PropTypes.func,
  saveLocal : PropTypes.bool,
  onSaveLocal: PropTypes.func
};

UniversalDetailsDialog.defaultProps = {
  open: false,
  required_fields: [],
  initForm: {},
  maxWidth: "sm",
  disabledButton : false,
  saveLocal : false
};

export default UniversalDetailsDialog;
